/**
 * 路由配置
 */

import { createRouter, createWebHistory } from "vue-router";
import AppLayout from "@/components/Layout/AppLayout.vue";
import { TOKEN_KEY } from "@/composables/useAuth";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/tasks",
    },
    {
      path: "/",
      component: AppLayout,
      children: [
        {
          path: "",
          redirect: "/tasks",
        },
        {
          path: "tasks",
          name: "Tasks",
          component: () => import("@/views/TasksView.vue"),
          meta: {
            title: "任务管理",
          },
        },
        {
          path: "clients",
          name: "Clients",
          component: () => import("@/views/ClientsView.vue"),
          meta: {
            title: "客户端管理",
          },
        },
        {
          path: "metrics",
          name: "Metrics",
          component: () => import("@/views/MetricsView.vue"),
          meta: {
            title: "指标监控",
          },
        },
        {
          path: "logs",
          name: "Logs",
          component: () => import("@/views/LogsView.vue"),
          meta: {
            title: "日志",
          },
        },
        {
          path: "settings",
          name: "Settings",
          component: () => import("@/views/SettingsView.vue"),
          meta: {
            title: "系统设置",
          },
        },
      ],
    },
    {
      path: "/auth",
      name: "Auth",
      component: () => import("@/views/AuthView.vue"),
      meta: {
        title: "API 认证",
        public: true,
      },
    },
    {
      path: "/:pathMatch(.*)*",
      name: "NotFound",
      component: () => import("@/views/NotFoundView.vue"),
      meta: {
        title: "页面未找到",
      },
    },
  ],
});

// 路由守卫：认证检查和页面标题
router.beforeEach((to, _from, next) => {
  const title = (to.meta.title as string) || "Kotori任务平台";
  document.title = `${title} - Kotori`;

  const token = localStorage.getItem(TOKEN_KEY);

  // 公开页面直接放行
  if (to.meta.public) {
    // 如果已登录且访问 /auth，跳转到首页
    if (token && to.path === "/auth") {
      return next("/tasks");
    }
    return next();
  }

  // 需要认证但未登录
  if (!token) {
    return next({
      path: "/auth",
      query: { redirect: to.fullPath },
    });
  }

  next();
});

export default router;
